import { shopifyAppSlug } from '../constants/environment';
import { SHOPIFY_ADMIN_FALLBACK_URL } from '../constants/shopify';

/**
 * Minimal local mirror of App Bridge's `SaveBarApi`, covering only the members we call.
 *
 * Deliberately not imported from `@shopify/app-bridge-types`
 * that package's `declare global` block also merges a `variant` prop ("primary" | "breadcrumb") into
 * React.ButtonHTMLAttributes, which collides with the `variant` on our own components
 * in every program that transitively includes this file — including forms-automations.
 */
export interface SaveBarApi {
  show?(id: string): Promise<void>;
  hide?(id: string): Promise<void>;
}

export function getShopifyAppLink(storeId: string) {
  return `https://${storeId}/admin/apps/${shopifyAppSlug}`;
}

/** Falls back to the Shopify admin home when the connected store is unknown. */
export function getShopifyAppSetupLink(storeId: string | undefined) {
  return storeId ? `${getShopifyAppLink(storeId)}/setup` : SHOPIFY_ADMIN_FALLBACK_URL;
}

export function getSaveBar(): SaveBarApi | undefined {
  return (globalThis as typeof globalThis & { shopify?: { saveBar?: SaveBarApi } }).shopify
    ?.saveBar;
}
